import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Product } from '../../product';
import { dinero, toSnapshot } from 'dinero.js';
import { mergeMap, tap } from 'rxjs/operators';
import { Store } from '../../../store/store';
import { StoreService } from '../../../store/store.service';
import { ProductPayloadService } from '../../product-payload/product-payload.service';
import { EMPTY, Observable } from 'rxjs';
import { ProductFormComponent } from '../../product-form/product-form.component';
import { CAD } from '@dinero.js/currencies';
import { Image } from '../../../shared/image-upload/image';
import { Category } from '../../../main-shared/categories-display/category';
import { CategoryService } from '../../../main-shared/categories-display/category.service';

@Component({
  selector: 'app-add-product-form',
  templateUrl: './add-product-form.component.html',
  styleUrls: ['./add-product-form.component.scss'],
})
export class AddProductFormComponent implements OnInit {
  @Input() store!: Store;
  @Output() addedProduct: EventEmitter<Product> = new EventEmitter<Product>();
  productFormComponent: ProductFormComponent | undefined;
  addProductForm: UntypedFormGroup = new UntypedFormGroup({
    product: new UntypedFormControl(''),
  });
  addButton = 'Ajouter Produit';
  categories$: Observable<Category[]> | undefined;
  submitted = false;

  constructor(
    private readonly storeService: StoreService,
    private readonly productPayloadService: ProductPayloadService,
    private readonly categoryService: CategoryService
  ) {}

  ngOnInit(): void {
    if (!this.store) throw new Error('store is null');
    this.categories$ = this.categoryService.getAllCached();
  }

  @ViewChild('productForm') set productForm(
    formComponent: ProductFormComponent
  ) {
    if (formComponent) {
      this.productFormComponent = formComponent;
    }
  }

  submitNewProduct(): void {
    if (this.addProductForm?.valid && this.productFormComponent) {
      this.submitted = true;
      const productForm = this.addProductForm.get('product')?.value;
      let price = productForm.price * 100;
      if (productForm.free) {
        price = 0;
      }
      const imagesInput = productForm.imagesInput ?? [];
      const newProduct: Product = {
        store: this.store.id ?? '',
        name: productForm.name,
        description: productForm.description,
        price: toSnapshot(
          dinero({
            amount: price,
            currency: CAD,
          })
        ).amount,
        images: imagesInput
          .filter((image: Image) => image.data != '')
          .map((image: Image) => image.data),
        categories: this.productFormComponent.getSelectedCategories(),
      };
      const filesInput = productForm?.filesInput;
      this.storeService
        .createStoreProduct(newProduct)
        .pipe(
          tap((createdProduct) => this.addedProduct.emit(createdProduct)),
          mergeMap((createdProduct) =>
            filesInput && filesInput[0] !== ''
              ? this.productPayloadService.createProductPayload({
                  files: filesInput,
                  product: createdProduct.id!,
                })
              : EMPTY
          )
        )
        .subscribe((event) => {
          this.submitted = false;
          this.addProductForm.reset();
        });
    }
  }
}
